import { Action } from '../../redux/redux.types';

import { TEAM_MEMBERS_FILTER_BY_PROJECT_OPTION_ALL } from './team-projects-filter/team-projects-filter';
import { TEAM_MEMBERS_ACTION_NAMES } from './team.actions';
import { TeamMemberRoles } from './team.constants';
import { TeamMember } from './team.types';

export interface TeamUiState {
  editingTeamMember?: TeamMember;
  deletingTeamMember?: TeamMember;
  isAddTeamMemberModalOpened: boolean;
  isTeamMemberDeleteModalOpened: boolean;
  isTeamMemberEditModalOpened: boolean;
  teamMembersSelectedProjectId: string;
  teamMembersSelectedRole: TeamMemberRoles;
  teamMembersSearchValue: string;
}

export const teamUiDefaultState: TeamUiState = {
  editingTeamMember: undefined,
  deletingTeamMember: undefined,
  isAddTeamMemberModalOpened: false,
  isTeamMemberDeleteModalOpened: false,
  isTeamMemberEditModalOpened: false,
  teamMembersSelectedProjectId: TEAM_MEMBERS_FILTER_BY_PROJECT_OPTION_ALL,
  teamMembersSelectedRole: TeamMemberRoles.All,
  teamMembersSearchValue: '',
};

export const teamUiState = (
  state: TeamUiState = teamUiDefaultState,
  { type, payload }: Action,
): TeamUiState => {
  switch (type) {
    case TEAM_MEMBERS_ACTION_NAMES.OPEN_ADD_MEMBER_MODAL:
      return {
        ...state,
        isAddTeamMemberModalOpened: true,
      };

    case TEAM_MEMBERS_ACTION_NAMES.CLOSE_ADD_MEMBER_MODAL:
      return {
        ...state,
        isAddTeamMemberModalOpened: false,
      };

    case TEAM_MEMBERS_ACTION_NAMES.OPEN_DELETE_MEMBER_MODAL:
      return {
        ...state,
        // TODO: add to store only member id
        deletingTeamMember: payload,
        isTeamMemberDeleteModalOpened: true,
      };

    case TEAM_MEMBERS_ACTION_NAMES.CLOSE_DELETE_MEMBER_MODAL:
      return {
        ...state,
        deletingTeamMember: undefined,
        isTeamMemberDeleteModalOpened: false,
      };

    case TEAM_MEMBERS_ACTION_NAMES.OPEN_MEMBER_EDIT_MODAL:
      return {
        ...state,
        editingTeamMember: payload,
        isTeamMemberEditModalOpened: true,
      };

    case TEAM_MEMBERS_ACTION_NAMES.CLOSE_MEMBER_EDIT_MODAL:
      return {
        ...state,
        editingTeamMember: undefined,
        isTeamMemberEditModalOpened: false,
      };

    case TEAM_MEMBERS_ACTION_NAMES.OPEN_MEMBER_DELETE_MODAL_FROM_EDIT_MODAL:
      return {
        ...state,
        deletingTeamMember: state.editingTeamMember,
        isTeamMemberDeleteModalOpened: true,
      };

    case TEAM_MEMBERS_ACTION_NAMES.FILTER_TEAM_MEMBERS_BY_PROJECT:
      return {
        ...state,
        teamMembersSelectedProjectId: payload,
      };

    case TEAM_MEMBERS_ACTION_NAMES.FILTER_TEAM_MEMBERS_BY_ROLE:
      return {
        ...state,
        teamMembersSelectedRole: payload,
      };

    case TEAM_MEMBERS_ACTION_NAMES.FILTER_TEAM_MEMBERS_BY_SEARCH:
      return {
        ...state,
        teamMembersSearchValue: payload,
      };

    default:
      return state;
  }
};
